import { Injectable, EventEmitter, inject } from '@angular/core';
import { BehaviorSubject, Subscription, Subject, interval, takeUntil } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AdobeAnalyticsService } from '../adobe-analytics/adobe-analytics.service';

@Injectable({
  providedIn: 'root',
})
export class SessionServiceService {
  readonly localHttp = inject(HttpClient);
  private adobeAnalyticsService = inject(AdobeAnalyticsService);


  observableSessionTimer: any;
  public renewTimer = new BehaviorSubject<any>('');
  intervalCancelsubject = new Subject();
  private url!: string;
  unsubscribeTimer: any = false;
  sessionTimeExpire: any;
  finishTimer = false;
  timeInterval = interval(1000);
  sessionTimerSubscription!: Subscription;
  renewTimerSubscription!: Subscription;
  /* Sets to initiate the session time out overlay */
  triggerSessionOverlay: EventEmitter<boolean> = new EventEmitter(); //
  sessionOverlaySubscription!: Subscription;

  public getURL() {
    if (
      window &&
      window.location &&
      window.location.host &&
      window.location.protocol
    ) {
      this.url = window.location.protocol + '//' + window.location.host + '/';
      // for local testing
      // this.url = 'http://localhost:8080/';
      return this.url;
    } else {
      return 'Error in getting the host details';
    }
  }

  startTimer: Function = () => {
    this.renewTimerSubscription = this.renewTimer.subscribe((data) => {
      const time = 480000; // 8 mins
      this.sessionTimeExpire = time - (data.nowTime - data.timeToRenew);
      this.sessionTimeExpire = this.sessionTimeExpire - 120000;
      this.observableSessionTimer = interval(this.sessionTimeExpire);
      this.subscribeSessionTimer();
    });
    // this. observableSessionTimer = Observable.interval(this.sessionTimeExpire);
    // alert('inbetween timer')
  };

  /**
   * @Method: resetSession
   * @Description: Reset session after each http service request responded and for extended session.
   */
  resetSession: Function = () => {
    // injecting like below to resolve the circular injection issue
    // this.unSubscribeSessionTimer();
    const url =
      this.getURL() + 'MXGCB/apps/renewsession/renewSessionAction.action';
    this.localHttp.get(url).subscribe((data) => {
      if (data) {
        this.renewTimer.next(data);

        this.startTimer();
        this.unsubscribeTimer = true;
      } else {
        // alert('logout while reset session')
        this.unsubscribeTimer = false;
        // logout the application
        this.unSubscribeSessionTimer();
        window.location.href =
          this.getURL() + 'MXGCB/apps/logout/flow.action?logOutType=timeOut';
      }
    });
    // setTimeout(this.subscribeSessionTimer,0);

    const urlSession =
      this.getURL() + 'MXGCB/apps/renewsession/resetTime.action';
    this.localHttp.get(urlSession).subscribe((data) => {
      // fired this http call to maintain the backend session
    });
  };
  /**
   * @Method: subscribeSessionTimer
   * @Description: Subscrbing observable session timer to emit the session overaly
   */
  subscribeSessionTimer: Function = () => {
    //  this.renewTimerSubscription.unsubscribe();
    this.sessionTimerSubscription = this.observableSessionTimer
      .pipe(takeUntil(this.intervalCancelsubject))
      .subscribe(
        () => {
          this.intervalCancelsubject.next('cancelTimeInterval'); // this cancels the timer subscriptions using take until
          this.sessionTimerSubscription.unsubscribe();
          this.triggerSessionOverlay.emit(true);
    /**
     * Begin R03.2024
     * Add analytics sesionTimeOut ADA
     */
            this.adobeAnalyticsService.modalTracking(
            '',
            '',
            'MX|BNP|TiempoSesionPorFinalizar',
            'event76',
            'MX|BNP|TiempoSesionPorFinalizar',
            '',
            '',
            );
    //End
          // this.unSubscribeSessionTimer();
        },
        (err: any) => {
          //  alert("Unable to continue session timer");
        },
      );
  };

  getTriggerSessionoverlay() {
    return this.triggerSessionOverlay;
  }
  /**
   * @Method: unSubscribeSessionTimer
   * @Description: Unsubscribing Observable session timer
   */
  unSubscribeSessionTimer: Function = () => {
    if (this.sessionTimerSubscription) {
      this.sessionTimerSubscription.unsubscribe();
    }
  };

  /**
   * @Method: Logout
   * Description: Access logout service to logout
   */
  logout: Function = () => {
    //  alert('logout session')
    window.location.href =
      this.getURL() + 'MXGCB/apps/logout/flow.action?logOutType=timeOut';
  };

  /**
   * @Method: LogoutManual
   * Description: Access logout service to logout manualy
   */
  logoutManual: Function = () => {
    window.location.href =
      this.getURL() + 'MXGCB/apps/logout/flow.action?logOutType=manual';
  };
}
